import styled from "../_snowpack/pkg/@emotion/styled.js";
import React from "../_snowpack/pkg/react.js";
import Component from "./editable-component.js";
import HeroAbout from "./hero-about.js";
import {media} from "./theme.js";
import ContentModules from "./content-modules.js";
export default function AboutPage(props) {
  const [HeroModule] = props.about_hero;
  const PageModules = props.modules;
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Component, {
    ...props
  }, /* @__PURE__ */ React.createElement(HeroAbout, {
    ...HeroModule
  }), PageModules && /* @__PURE__ */ React.createElement(ContentModules, {
    modules: PageModules,
    isProductPage: false,
    isAboutPage: true
  })));
}
const Container = styled.div`
  padding: 0;
  margin: auto;

  ${media.mobile} {
    padding-top: 32px;
  }
`;
